export default (host, onMessage, onConnect, onDisconnect) => {
  const client = { reconnect: true }

  const onClose = () => {
    onDisconnect()

    client.reconnect
      ? setTimeout(client.connect, 1500)
      : client.unregister()
  }

  const onError = (err) => {
    console.log(err)
    if (client.reconnect) setTimeout(client.connect, 1500)
  }

  client.connect = () => {
    client.unregister()

    try {
      client.socket = new WebSocket(host)
      client.socket.addEventListener('open', onConnect)
      client.socket.addEventListener('close', onClose)
      client.socket.addEventListener('error', onError)
      client.socket.addEventListener('message', onMessage)
    } catch (err) {
      console.log(err)
      onClose()
    }
  }

  client.unregister = () => {
    if (!client.socket) return

    try {
      client.socket.removeEventListener('open', onConnect)
      client.socket.removeEventListener('close', onClose)
      client.socket.removeEventListener('error', onError)
      client.socket.removeEventListener('message', onMessage)
      client.socket.close()
    } finally {
      client.socket = null
    }
  }

  client.close = () => {
    client.reconnect = false
    client.unregister()
    onDisconnect()
  }

  client.drop = () => {
    client.reconnect = false
    client.unregister()
  }

  client.send = (msg) => {
    if (!client.socket || client.socket.readyState !== WebSocket.OPEN) return
    client.socket.send(JSON.stringify(msg))
  }

  client.connect()

  return client
}
